export interface AnalyticsEvent {
  event: string;
  params?: Record<string, string | number>;
}

export const ANALYTICS_EVENTS_COOKIE = "_ga_pending_events";
export const COOKIE_MAX_AGE = 31536000; // 365 days in seconds
